export const CATEGORIES = 'CATEGORIES';
export const CATEGORY_SLIDES = 'CATEGORY_SLIDES';
export const PRODUCTS = 'PRODUCTS';
export const ARRIVAL_SLIDES = 'ARRIVAL_SLIDES';
export const SEARCH = 'SEARCH';
